import { Link } from 'react-router-dom'
import Navbar from '../components/marketing/Navigation'
import Footer from '../components/marketing/Footer'

export default function ScrimmageBulletinLanding() {
  return (
    <div className="font-body text-brand-charcoal bg-white min-h-screen flex flex-col">
      <Navbar />

      <section className="relative pt-24 pb-24 flex-grow">
        {/* Background Blobs */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 -z-10"></div>
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-brand-amber/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4 -z-10"></div>

        <div className="container mx-auto px-6 relative z-10 max-w-4xl">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-brand-green/10 text-brand-green font-semibold text-sm tracking-wide uppercase border border-brand-green/20">
              Scrimmage Bulletin
            </div>
            <h1 className="font-heading text-4xl lg:text-6xl font-bold text-brand-charcoal mb-6">
              Find Open Ice in Minnesota
            </h1>
            <p className="text-xl text-brand-slate max-w-2xl mx-auto">
              We scan 200+ association calendars hourly to find teams with solo practice ice. Filter by level, distance, and date.
            </p>
          </div>

          {/* Hockey - Primary Sport */}
          <div className="max-w-lg mx-auto">
            <Link
              to="/scrimmages/bulletin/hockey"
              className="block group"
            >
              <div className="bg-white rounded-3xl p-10 border-2 border-brand-green/20 shadow-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:border-brand-green/40 cursor-pointer text-center">
                <div className="w-24 h-24 rounded-2xl bg-blue-50 flex items-center justify-center text-5xl mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
                  🏒
                </div>

                <h2 className="font-heading text-3xl font-bold text-brand-charcoal mb-3">
                  Youth Hockey
                </h2>
                <p className="text-brand-slate text-lg mb-6">
                  Find scrimmage partners across all 13 Minnesota Hockey districts
                </p>

                <div className="flex flex-wrap justify-center gap-2 mb-6">
                  <span className="px-3 py-1 bg-brand-cream text-brand-charcoal text-xs font-medium rounded-full">Mites</span>
                  <span className="px-3 py-1 bg-brand-cream text-brand-charcoal text-xs font-medium rounded-full">Squirts</span>
                  <span className="px-3 py-1 bg-brand-cream text-brand-charcoal text-xs font-medium rounded-full">Peewee</span>
                  <span className="px-3 py-1 bg-brand-cream text-brand-charcoal text-xs font-medium rounded-full">Bantam</span>
                  <span className="px-3 py-1 bg-brand-cream text-brand-charcoal text-xs font-medium rounded-full">U14+</span>
                </div>

                <span className="inline-flex items-center px-6 py-3 bg-brand-green text-white font-bold rounded-xl group-hover:bg-brand-green/90 transition-colors">
                  Browse Hockey Scrimmages
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </span>
              </div>
            </Link>
          </div>

          {/* More Sports Coming - Subtle */}
          <div className="max-w-2xl mx-auto mt-16 text-center">
            <div className="border-t border-gray-200 pt-8">
              <p className="text-sm text-brand-slate mb-2">
                More sports coming in 2025
              </p>
              <div className="flex justify-center gap-6 text-2xl opacity-40">
                <span title="Soccer">⚽</span>
                <span title="Basketball">🏀</span>
                <span title="Baseball">⚾</span>
                <span title="Volleyball">🏐</span>
                <span title="Lacrosse">🥍</span>
              </div>
              <p className="mt-4 text-xs text-brand-slate/70">
                Want us to add your sport? <a href="mailto:support@benchbulletin.com" className="text-brand-green hover:underline">Let us know</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}
